import MkuTabs from './src/tabs';

MkuTabs.install = function (Vue) {
  Vue.component(MkuTabs.name, MkuTabs);
};

export default MkuTabs;
